import { PROVINCE } from '@ratehub/base-ui';

import createBaseConversionPayload from './createBaseConversionPayload';


/**
 * Create a payload to send to the Conversion Service for a mortgage CPA click
 * @param {object} params - The parameters for creating the CPA payload.
 * @param {object} params.lead - The lead information, including city and province details.
 * @param {object} params.rate - The current rate being inquired on.
 * @param {object} params.experiments - The active front-end experiments.
 * @param {string} params.locale - The locale of the user.
 * @returns {object} conversion payload
 */
export default function createCPAPayload({ lead, rate, experiments, locale }) {
    // These are REQUIRED by Conversion Service, but if GeoIP fails, we may not have their information.
    // Better to just include garbage information than lose the conversion.
    // Credit-cards is doing the same - modeling after their approach.
    const cityName = lead?.city?.name ?? 'Toronto';
    const provinceCode = lead?.city?.province?.code ?? PROVINCE.ONTARIO;

    return {
        ...createBaseConversionPayload({ rate, cityName, provinceCode, locale, experiments }),
        'type': 'CPA_CLICK',
        'productType': 'MORTGAGE',
        'conversionSourceType': 'MORTGAGE_RATE',
    };
}
